import React from "react";

interface SelectableCardProps {
  image: string;
  text: string;
  selected: boolean;
  onClick: () => void;
}

const SelectableCard: React.FC<SelectableCardProps> = ({
  image,
  text,
  selected,
  onClick,
}) => {
  return (
    <div
      onClick={onClick}
      className={`card text-center p-2 d-flex flex-column align-items-center justify-content-center shadow-md`}
      style={{
        width: "80px",
        height: "80px",
        cursor: "pointer",
        margin: "5px",
        border: selected ? "2.2px solid #14C6A4" : "1.7px solid #D7DBEC",
      }}
    >
      <img
        src={image ? `images/${image}.svg` : "images/Sepah.png"}
        alt={text}
        style={{ width: "40px", height: "40px", objectFit: "contain" }}
      />
      <span className="small mt-2">{text}</span>
    </div>
  );
};

export default SelectableCard;
